import React from "react";

export const FAQSection = () => {
  return (
    <div className="faqContainer">
      <div className="container">
        <div className="faqTitle">Frequently Asked Questions</div>
        <div className="faqDesc">
          Find answers to common questions about Estatein's services, property
          listings, and the real estate process. We're here to provide clarity
          and assist you every step of the way.
        </div>
        <div className="faqCard">
          <div>How can I visit the property?</div>
          <div>
            To schedule a visit, click the “Apply for Bid” button and pay a
            non-refundable application fee of ₹1,000. After admin verifies your
            payment, you’ll be able to choose a visit date from your dashboard.
          </div>
        </div>
        <div className="faqCard">
          <div>What documents are available for verification?</div>
          <div>
            All properties on SnapBid are pre-verified. Official documents like
            the title deed and site plan will be shown during your scheduled
            site visit, not before.
          </div>
        </div>
        <div className="faqCard">
          <div>How does offline bidding work?</div>
          <div>
            Once all initial bids are submitted, top bidders are shortlisted
            based on amount, timing, and profile. Shortlisted users are invited
            to an offline bidding session after paying a refundable registration
            fee.
          </div>
        </div>
      </div>
    </div>
  );
};
